<template>
	<q-card
		class="shadow-transition q-py-sm full-height card-activity relative-position cursor-pointer"
		:class="class_hover"
		@mouseover="setClassHover('mouseover')"
		@mouseleave="setClassHover('mouseleave')"
		@click="openReaction()"
	>
		<q-card-section>
			<div class="row q-col-gutter-md">
				<div class="col-8">
					<q-icon
						:name="$extensionIcon(reaction.type_activity).icon"
						size="lg"
						:color="$extensionIcon(reaction.type_activity).color"
					/>
				</div>

				<div class="col-4 text-right">
					<q-icon size="sm" :name="statusIcon" :color="statusColor" />
				</div>

				<div class="col-12">
					<span class="text-h5 title">
						{{ reaction.title }}
					</span>
					<span class="text-grey-6">
						{{ $t('reaction_evaluation') }}
					</span>
				</div>
			</div>
		</q-card-section>

		<q-tooltip
			v-if="!reaction.allowed_to_answer || webcast.status === 1"
			anchor="center middle"
			self="center middle"
			class="bg-primary"
			style="font-size: 16px"
		>
			{{ $t('you_need_to_end_the_training_before_you_can_respond_to_the_reaction_assessment') }}
		</q-tooltip>
	</q-card>
</template>

<script>
export default {
	name: 'CourseReaction',

	props: ['reaction', 'webcast'],

	data() {
		return {
			class_hover: '',
			hover: false,
		}
	},

	computed: {
		statusIcon() {
			if (this.reaction) {
				if (this.reaction.answered) return 'fas fa-badge-check'
				else if (!this.reaction.allowed_to_answer) return 'fas fa-lock'
			}
			return ''
		},

		statusColor() {
			if (this.reaction) {
				if (this.reaction.answered) return 'positive'
				else if (!this.reaction.allowed_to_answer) return 'grey-6'
			}
		},
	},

	methods: {
		openReaction() {
			if (
				(this.webcast.webcast_user_subscribed &&
					this.reaction.allowed_to_answer &&
					this.webcast.status == 4) ||
				(this.webcast.webcast_user_subscribed && this.reaction.answered && this.webcast.status == 4)
			) {
				if (this.$route.name !== 'trail_webinar')
					this.$router.push({
						name: 'webinar_activity',
						params: { id: this.$route.params.id, hierarchy_order: this.reaction.hierarchy_order },
					})
				else
					this.$router.push({
						name: 'trail_webinar_activity',
						params: {
							id_trail: this.$route.params.id_trail,
							id: this.$route.params.id,
							hierarchy_order: this.reaction.hierarchy_order,
						},
					})
			}
		},

		setClassHover(state) {
			if (
				!this.reaction.allowed_to_answer ||
				!this.webcast.webcast_user_subscribed ||
				this.webcast.status === 1
			)
				this.class_hover = 'disabled'
			else {
				if (state === 'mouseover') this.class_hover = 'shadow-5'
				else this.class_hover = ''
			}
		},
	},

	created() {
		if (
			!this.reaction.allowed_to_answer ||
			!this.webcast.webcast_user_subscribed ||
			this.webcast.status === 1
		)
			this.class_hover = 'disabled'
	},
}
</script>

<style lang="scss" scoped>
.title {
	font-size: 0.905rem;
	font-weight: 800;
	line-height: 1.2rem;
	min-height: 57px;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.card-activity {
	min-height: 250px;
}
</style>
